// @core/stores/activity/ActivityInboxStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { activityApi } from '@core/api';
import type {
  AcknowledgeActivitiesRequest,
  AcknowledgeActivitiesResponse,
  AcknowledgeAllRequest,
  AcknowledgeAllResponse,
  GetInboxCountsResponse,
  ListInboxResponse,
} from '@core/types/activity';

class ActivityInboxStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Acknowledge activities
   */
  async AcknowledgeActivities(data: AcknowledgeActivitiesRequest): Promise<AcknowledgeActivitiesResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.AcknowledgeActivities(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Acknowledge all matching activities
   */
  async AcknowledgeAll(data: AcknowledgeAllRequest): Promise<AcknowledgeAllResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.AcknowledgeAll(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Get inbox counts
   */
  async GetInboxCounts(params?: { }): Promise<GetInboxCountsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.GetInboxCounts(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * List inbox items
   */
  async ListInbox(params?: { cursor?: string | number | boolean; direction?: string | number | boolean; filter?: string | number | boolean; limit?: string | number | boolean; scope?: string | number | boolean; scope_id?: string | number | boolean; sort?: string | number | boolean; }): Promise<ListInboxResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await activityApi.ListInbox(params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const activityInboxStore = new ActivityInboxStore();
